/**
 * Utility to get the application version from package.json
 * 
 * In a real-world implementation, this would dynamically access the version from package.json.
 * For this demo, we're using a constant to simulate that behavior.
 * 
 * In a production React app, this could be implemented in several ways:
 * 1. At build time using environment variables: process.env.REACT_APP_VERSION = require('../package.json').version
 * 2. Using webpack's DefinePlugin to inject version at build time
 * 3. Using an API endpoint that returns the current version from the server
 */

// Simulating package.json version value
const pjson = require('../../package.json');
const APP_VERSION = pjson.version;

/**
 * Get the current application version
 */
export const getAppVersion = (): string => {
  return APP_VERSION;
};

/**
 * Check if the current version is a beta version
 */
export const isBetaVersion = (): boolean => {
  // In a real app, you might check if version contains beta, alpha, etc.
  // For this demo, we'll just return true
  return true;
};
